export const environment = {
  production: false,
  apiUrl: 'https://ukcs.invenit.io/graphql',
  socketUrl: 'wss://ukcs.invenit.io/graphql',
  uploadEndpoint: 'https://ukcs.invenit.io/api/Files/upload',
  downloadFile: 'https://ukcs.invenit.io/api/waitinglists/export-document',
  rootUrl: 'https://ukc.invenit.io'
};
